import { useState, useRef, useEffect, useLayoutEffect } from "react";
import * as d3sc from 'd3-scale';
import { treemapSquarify } from "d3-hierarchy";

export default function TimelineWithMiniMap({ domain_matches, corrections, currentRoom,
                   startDate, setStartDate,
                   scrollMessages, username, polarities, 
                   pointed_message, threshold, map_domains=[] }) {
  const containerRef = useRef(null);
  const [message_events, setMessageEvents] = useState([])
  const pendingMouseEvent = useRef(null)

  const [zoom, setZoom] = useState(0.00000003625); // px per ms
  const [vPortLeft, setVPortLeft] = useState(0); // px per ms
  const [minDate, setMinDate] = useState(null);
  const [maxDate, setMaxDate] = useState(null);
  const [timelineWidth, setTimelineWidth] = useState(5000);

  // For mini-map drag
  const miniMapRef = useRef(null);
  const colorScale = useRef(null);  // début et fin du gradient

  const overThresholdMessages = useRef([])
  const post_pointed_messages = useRef([])
  const [bubbleIds, setBubbleIds] = useState([])
  const miniMapVPortRef = useRef(null);
  const isDraggingMini = useRef(false);

 useLayoutEffect(() => {
  if (pendingMouseEvent.current == null) return;
    computeVPortLeft(pendingMouseEvent.current)
    pendingMouseEvent.current = null
  }, [zoom]);
  useEffect( () => {
    function buildColorScale() {
      if (bubbleIds.length <= 0) return null
      const colorTableLength = startDate == null ? bubbleIds.length : bubbleIds.filter(b => parseInt(b) >= startDate).length
      const res = d3sc.scaleLinear()
        .domain([0, colorTableLength - post_pointed_messages.current.length]) // index des étapes
        .range(["#f9e105ff", "#0ceaf9ff" ]); 
      return res
    }
    colorScale.current = buildColorScale()
  }, [bubbleIds, startDate])

  const getColorIndexForSelected = (i => {
    const m_id = bubbleIds[i]
    const sb = bubbleIds.filter((b) => parseInt(b) >= startDate)
    if (sb.length == 1) return "0ceaf9ff"
    const index = sb.findIndex((b) => b == m_id)
    if (index == -1) return 'grey' 
    
    return colorScale.current(index)
  })

  const getMiniColor =  (t, i) => {
    if (colorScale.current === null || i < 0 || (i >= bubbleIds.length - post_pointed_messages.current.length)) return 'white'
    const res = startDate == null ? colorScale.current(i) : getColorIndexForSelected(i)
    return res
  }

  useEffect( () => {
      const now = new Date()
      setMaxDate(now)
      setTimelineWidth((now - minDate + 180000) * zoom); // 3 mn of margin
  }, [zoom]);



  useEffect(() => {
    const displayed_message_ids = []
    const events = Array.from(domain_matches)
    const corr_events = Array.from(corrections)
    const merged_events = []
    corr_events.reverse().map((evt => {
      if (evt.roomId === currentRoom && 
        ! (evt.message_id in displayed_message_ids)) {
        displayed_message_ids.push(evt.message_id)
        merged_events.push(evt)
      }
    }))
   events.map((evt,i) => {
      if (evt[1].roomId === currentRoom && 
        evt[1].matched_domains.length > 0 &&
        ! (evt[1].id in displayed_message_ids)) {
        merged_events.push(evt[1])
      } // "1782313966321"
    })
    const sorted_events = merged_events.sort((a, b) => {
            const ia = a.target_path ? a.message_id : a.id
            const ib = b.target_path ? b.message_id : b.id
            return ia > ib
          })
    setMessageEvents(sorted_events)
    if (merged_events.sort((a, b) => {
            const ia = a.target_path ? a.message_id : a.id
            const ib = b.target_path ? b.message_id : b.id
            return ia > ib
          }).length > 0) {
      const min = Math.min(...message_events.map(e => parseInt(e['message_id'] ? e['message_id'] : e['id'] )));
      const max = Math.max(...message_events.map(e => parseInt(e['message_id'] ? e['message_id'] :  e['id'] )));
      const now = new Date()
      setMinDate(min);
      setMaxDate(max);
      setTimelineWidth((now - min + 6000) * zoom); // 1 mn of margin
    }
  }, [domain_matches]);

  useEffect( () => {

    overThresholdMessages.current = []
    post_pointed_messages.current = []
    message_events.map((evt, i) => {
            const isCorrection = evt['message_id'] != null
            const m_id = isCorrection ? evt['message_id'] : evt['id']
            const similarity = isCorrection ? evt.strength : evt['matched_domains'][0] && evt['matched_domains'][0]['pondered_similarity'] ? evt['matched_domains'][0]['pondered_similarity'] : 0.2
            const tp = evt['target_path']
            if (isCorrection) {
              if ( tp === undefined) return
              const tpa = tp.split('/')
              if (tpa.length < 2) return
            } 
            if (similarity < threshold) return
            

            if (overThresholdMessages.current.indexOf(m_id) < 0) {
              overThresholdMessages.current.push(m_id)
              if (pointed_message != undefined && m_id > pointed_message) post_pointed_messages.current.push(m_id)
            }
    })
    setBubbleIds(overThresholdMessages.current.sort())
  }, [threshold, message_events, pointed_message ]);


  if (!minDate) return "";

  const getX = (date) => {
    const res = (date - minDate) * zoom;
    return res;
  }

  const getDate = (x) => {
    const container = containerRef.current;
    const sl = container.scrollLeft

    const pos = x / timelineWidth / zoom * 100 +sl ; // % for scaling

    // const x = (getX(parseInt(m_id)) / timelineWidth) * 100; // % for scaling
    const factor = (maxDate - minDate) / timelineWidth

    const res = pos * factor
    return res + minDate;
  }

  const getDomainY = (match) => {
    const nicky = match
    let res = map_domains.indexOf(nicky);
    if (res === -1) res = 0
    return res * 8;
  }

  const handleWheel = (e) => {
    e.stopPropagation();
    const oldZoom = zoom
    let newZoom = zoom
    const factor = 1.5;
    if (e.deltaY < 0) newZoom = oldZoom * factor;
    else newZoom = oldZoom / factor;
    pendingMouseEvent.current = e.clientX
    setZoom(newZoom)
  };

  const handleHorizWheel = (e) => { // sliding the viz window
    e.stopPropagation();
    const vpLeft = vPortLeft
    const factor = -0.2 * e.deltaY; // zoom
    const container = containerRef.current;
    const mini = miniMapRef.current;
    const ratio = 5 * timelineWidth / mini.clientWidth;
    // const nvpl = Math.max(0, vpLeft - e.deltaY * factor)
    const nvpl = vpLeft + factor / ratio
    if (nvpl < 0) return
    if (nvpl > mini.clientWidth) return
    const scl = container.scrollLeft + factor;
    setVPortLeft(nvpl)
    container.scrollLeft = scl;
  };

   /** Mini-map click to move viewport or set startDate*/
  const handleMiniMapClick = (e) => {
    e.stopPropagation();
    computeVPortLeft(e.clientX)
  }
   /** Mini-map click to move viewport or set startDate*/
  const handleMapBoardClick = (e) => {
    e.stopPropagation();
    computeStartDate(e)
  }

  const getDateFromPosition = (positionPercent) => {
    return minDate+ (positionPercent / 100) * (timelineWidth) / zoom;
  };


  const computeStartDate= (event) => {
    if (startDate != null) {
      setStartDate(null)
      return
    }
    const rect = event.currentTarget.getBoundingClientRect();
/*
    const positionPercent =
      ((event.clientX - rect.left + rect.scrollLeft) / rect.width) * 100;

    const startD = getDateFromPosition(positionPercent);

      const container = containerRef.current;
  const rect = container.getBoundingClientRect();
*/
  // Position dans la timeline complète, en pixels
  const container = containerRef.current;

  const x = event.clientX - rect.left + container.scrollLeft;

  // Conversion en timestamp
  const startD = minDate + x / zoom;

    setStartDate(startD)
  }

  const computeVPortLeft= (clientX) => {
    const mini = miniMapRef.current;
    const miniVPort = miniMapVPortRef.current;

    const container = containerRef.current;
    if (!mini || !container) return;

    const rect = mini.getBoundingClientRect();
    const x = Math.min(clientX - rect.left, mini.clientWidth - miniVPort.clientWidth / 2);
    const ratio = x / mini.clientWidth;
    const vpRaptio = Math.max(0, (x - miniVPort.clientWidth / 2) / mini.clientWidth);
    const scl = timelineWidth * ratio - container.clientWidth / 2;

    container.scrollLeft = scl;
    const loffsetpc = vpRaptio * 100 ; 
    setVPortLeft(loffsetpc)
  }
 
  /** Drag behavior on mini-map */
  const handleMiniDown = () => { isDraggingMini.current = true; };
  const handleMiniUp = () => { isDraggingMini.current = false; };

  const handleMiniMove = (e) => {
    if (!isDraggingMini.current) return;
    // handleMiniMapClick(e);
  };

  return (
    <div class="Timeline_main" style={{ width: "98%", margin: "0 auto", 'overflow' : 'hidden' }}>
      {/* Main timeline */}
      <div class="Timeline_board" 
        onWheel={handleHorizWheel}
        ref={containerRef}
        style={{
          width: "100%",
          height: (8 * map_domains.length) + "px",
          overflowX: "scroll",
          "scrollbar-width": 'none', /* Firefox */
          "-webkit-scrollbar" : { display: 'none' /* Chrome, Safari, Edge */ },
          border: "1px solid #ccc",
          background : "#395e65",
          position: "relative",
          whiteSpace: "nowrap",
        }}
      >

        <div  class="Timeline_bubbles"         
              onClick={handleMapBoardClick}
              style={{
            position: "relative",
            height: "100%",
            width: "100%",
              }}
        >
          <div  class="Timeline_bubbles" >
          { bubbleIds.map( (o, i) => {
            const evt = message_events.find(e => (e.message_id ? e.message_id : e.id) === o)
            if (evt === undefined) return
            const isCorrection = evt['message_id'] != null
            const m_id = isCorrection ? evt['message_id'] : evt['id']
            const x = (getX(parseInt(m_id)) / timelineWidth) * 100; // % for scaling

            const color = getMiniColor(m_id, i)
            const similarity = isCorrection ? evt.strength : evt['matched_domains'][0] && evt['matched_domains'][0]['pondered_similarity'] ? evt['matched_domains'][0]['pondered_similarity'] : 0.2
            const category = isCorrection ? evt.nickName : evt['matched_domains'][0] && evt['matched_domains'][0]['nickName'] ? evt['matched_domains'][0]['nickName'] : ' '
            const auteur = isCorrection ? 'correction' : evt['origin']
            const corrigé = isCorrection ? evt.target_path : 'non'

            return (
              <div  class="Timeline_bubble_back" 
                key={i}
                style={{
                  position: "absolute",
                  left: getX(parseInt(m_id)) + "px",
                  top: getDomainY(category) + "px",
                  height : pointed_message === m_id ? 10 : 0,
                  width : "4px",
                  opacity : 1,
                  backgroundColor : startDate == null || m_id > startDate ? color : 'darkGreen',
                  transform: "translateX(-50%)",
                }}
              >
                {/* Dot */}
                <div class="Timeline_bubble_dot" 
                  style={{
                    width: "6px",
                    height:  6 * similarity + "px",
                    borderRadius: "50%",
                    backgroundColor: startDate == null || m_id > startDate ? color : 'grey',
                    opacity: 1,
                    border: evt.signe === "-" ? "2px solid black" : "none",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                                    e.stopPropagation()
                                    scrollMessages(m_id)
                                  }}
                  title={
                    `${new Date(parseInt(m_id)).toLocaleString('fr-FR', {"dateStyle": "medium", 
                      "timeStyle": "short"})}\n` + 'exigence : ' + similarity + 
                    '\nAuteur : ' + auteur + '\n' +
                    '\nCorrigé : ' + corrigé + '\n' +
                    'Catégorie : ' + category + '\n\n' + `${evt['message']}`
                  }
                />
              </div>
            );
          })}
          </div>
        </div>
      </div>

      {/* Mini-map */}
      <div  class="Timeline_minimap" 
        ref={miniMapRef}
        onWheel={handleWheel}
        onMouseDown={handleMiniDown}
        onMouseUp={handleMiniUp}
        // onMouseMove={handleMiniMove}
        onClick={handleMiniMapClick}
        style={{
          marginTop: "1px",
          width: "100%",
          height: "8px",
          background: "#021317",
          position: "relative",
          cursor: "pointer",
          overflow: "hidden",
          borderRadius: "3px",
          border: "0.2px solid #efe066",
        }}
      >
        {/* Mini version of events */}
        {message_events.map((evt, i) => {
          const isCorrection = evt['message_id'] != null
          const m_id = isCorrection ? evt['message_id'] : evt['id']
          // const dd = Array.from(domain_matches)
          const x = (getX(parseInt(m_id)) / timelineWidth) * 100; // % for scaling
          const idx = bubbleIds.indexOf(m_id)
          const color = getMiniColor(m_id, idx)
          return (
            <div  class="Timeline_minimap_event" 
              key={i}
              style={{
                position: "absolute",
                left: x + "%",
                top: "50%",
                width: "0.05px",
                height: "26px",
                background: startDate == null || m_id > startDate ? color : 'darkGreen',
                borderRadius: "50%",
                border: "0.001px solid rgba(7, 0, 6, 0.6)",
                transform: "translate(-50%, -50%)",
                opacity: 1,
              }}
              title={
                    `${new Date(parseInt(m_id)).toLocaleDateString('fr-FR', { day: "2-digit", month: "short", year: "numeric" })}\n`
                  }

            />
          );
        })}

        {/* Viewport rectangle representing visible area */}
        {containerRef.current && (
          <div class="Timeline_minimap_viewport" 
        ref={miniMapVPortRef}
            style={{
              position: "absolute",
              top: 0,
              height: "10px",
              width:
                (containerRef.current.clientWidth / timelineWidth) * 100 + "%",
              left: `${vPortLeft}%`,
              background: "gold",
              border: "0.2px solid rgba(2, 28, 16, 0.6)",
              pointerEvents: "none",
              opacity : 0.2
            }}
          />
        )}
      </div>
    </div>
  );
}